import React, { useCallback } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { Breadcrumb } from '../../types/Folder';
import useStyles from './FolderBreadcrumbs.styles';

const MAX_NAME_LENGTH = 15;

function truncate(name: string) {
  return name.length > MAX_NAME_LENGTH
    ? `${name.slice(0, MAX_NAME_LENGTH)}...`
    : name;
}

interface BreadcrumbItemProps {
  crumb: Breadcrumb;
  isCurrent: boolean;
  onNavigate: (id: string) => void;
}

const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  crumb,
  isCurrent,
  onNavigate,
}) => {
  const classes = useStyles();
  const tooltipTitle = crumb.name.length > MAX_NAME_LENGTH ? crumb.name : '';

  const handleClick = useCallback(() => {
    onNavigate(crumb.id);
  }, [crumb.id, onNavigate]);

  return (
    <Tooltip
      title={tooltipTitle}
      placement="top"
      PopperProps={{ disablePortal: true }}
    >
      <Typography
        component="span"
        className={isCurrent ? classes.currentCrumb : classes.crumb}
        onClick={isCurrent ? undefined : handleClick}
      >
        {truncate(crumb.name)}
      </Typography>
    </Tooltip>
  );
};

export default React.memo(BreadcrumbItem);
